<template lang="pug">
div
  template(v-if="!showMobile")
    topbar
    .conbox
      .hometabs
        tabList
  .tabbox
    .gbox-wrap.casino
      .not-mobile.justify-content-end.mt-2
        .gbox-menu-fav
          template(v-if="isLoggedIn")
            a.sgbtn.s-fav(href='javascript:void(0)' @click="toggleFav")
              img(v-if="!showFav" src='assets/img/fav-ss.png')
              img(v-else src='assets/img/fav-set.png')
          template(v-else)
            a.sgbtn.s-fav(href='javascript:void(0)' @click="openModal()")
              img(v-if="!showFav" src='assets/img/fav-ss.png')
        .gbox-search-box.ss-search-box.aaa
          .search-games
            .iicon
              img(src='assets/img/search-icon.png')
            input.form-control(type='text' v-model="searchinput" placeholder='Search')
      .gbox-menu-wrap-add
        .gbox-menu-fav.only-mobile
          template(v-if="isLoggedIn")
            a.sgbtn.s-fav(href='javascript:void(0)' @click="toggleFav")
              img(v-if="!showFav" src='assets/img/fav-ss.png')
              img(v-else src='assets/img/fav-set.png')
          template(v-else)
            a.sgbtn.s-fav(href='javascript:void(0)' @click="openModal()")
              img(v-if="!showFav" src='assets/img/fav-ss.png')
        .gbox-search.ss-search.only-mobile(@click="toggleSearch")
          .iicon
            img(src='assets/img/search-icon.png')
        .gbox-menu-wrap
          .swiper.gbox-swiper
            .swiper-wrapper
              .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 2 }" @click="changeProvider(2)")
                a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 2 }")
                  img.pro-img(src='assets/img/provider/evolution-w.png')
                | Evolution
              //- .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 3 }" @click="changeProvider(3)")
                a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 3 }")
                  img.pro-img(src='assets/img/provider/pragmatic.png')
                | Pragmatic
              //- .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 3 }" @click="changeProvider(3)")
                a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 3 }")
                  img(src='assets/img/provider/jili.png')
                | Jili
              .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 0 }" @click="changeProvider(0)")
                a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 0 }")
                  img.pro-img(src='assets/img/provider/sexy-baccarat.png')
                | Sexy Baccarat
              .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 1 }" @click="changeProvider(1)")
                a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 1 }")
                  img.pro-img(src='assets/img/provider/venus-casino.png')
                | Venus Casino
              .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 4 }" @click="changeProvider(4)")
                a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 4 }")
                  img.pro-img(src='assets/img/provider/winfinity.png')
                | Winfinity
              .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 5 }" @click="changeProvider(5)")
                a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 5 }")
                  img.pro-img(src='assets/img/provider/yeebet.png')
                | YEEBET
              .swiper-slide.pointer(:class="{'active-slider' : providerSelected === 6 }" @click="changeProvider(6)")
                a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 6 }")
                  img.pro-img(src='assets/img/provider/tbl.png')
                | TB Live
      .gbox-search-box.ss-search-box(:class="{'aaa': showSearch}")
        .search-games
          input.form-control(type='text' v-model="searchinput" placeholder='Search')
        span.search-cancel.ss-search-cancel.pointer(@click="cancelSearch") {{$t('ui.cancel')}}
      favList(v-if="showFav" :searchinput="searchinput")
      sexybcrt(v-if="providerSelected === 0 && !showFav" :searchinput="searchinput")
      venus(v-if="providerSelected === 1 && !showFav" :searchinput="searchinput")
      evo(v-if="providerSelected === 2 && !showFav" :searchinput="searchinput")
      //- jili(v-if="providerSelected === 3 && !showFav" :searchinput="searchinput")
      //- pragmatic(v-if="providerSelected === 3 && !showFav" :searchinput="searchinput")
      winfinity(v-if="providerSelected === 4 && !showFav" :searchinput="searchinput")
      yeebet(v-if="providerSelected === 5 && !showFav" :searchinput="searchinput")
      tbl(v-if="providerSelected === 6 && !showFav" :searchinput="searchinput")
  footerInfo
</template>
<script>
import topbar from '@/views/default/_topBar.vue'
import tabList from '@/views/default/_tabs.vue'
import favList from '@/component/casino/_favList.vue'
import sexybcrt from '@/component/casino/_sexybcrt.vue'
import venus from '@/component/casino/_venus.vue'
import evo from '@/component/casino/_evo.vue'
// import jili from '@/component/casino/_jili.vue'
// import pragmatic from '@/component/casino/launchone/_pragmatic.vue'
import winfinity from '@/component/casino/launchone/_winfinity.vue'
import yeebet from '@/component/casino/launchone/_yeebet.vue'
import tbl from '@/component/casino/_tbl.vue'
import footerInfo from '@/views/default/_footer.vue'
export default {
  components:{
    topbar,
    tabList,
    favList,
    sexybcrt,
    venus,
    evo,
    // jili,
    // pragmatic,
    winfinity,
    yeebet,
    tbl,
    footerInfo
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      loading:false,
      showMobile: false,
      providerSelected: 2,
      showSearch: false,
      searchinput:"",
      showFav: false
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    },
  },
  watch:{
    sessionToken(newState, oldState){
      this.showFav = false
    }
  },
  created(){
    this.checkSize()
    var vm = this
    $(window).resize(function () {
      vm.checkSize()
    });
  },
  mounted(){
    if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.provider === "00"){
				this.showFav = true
			}else{
				this.providerSelected = this.$route.params.provider
			}
    }
    $(document).on('click', '.ss-filbox-close', function () {
        $(this).closest('.modal-filbox').removeClass('aaa')
        $('body').removeClass('noscroll')
        return false;
    })
    if ($('.gbox-swiper').length) {
      const gboxSwiper = new Swiper('.gbox-swiper', {
        slidesPerView: 2.5,
        spaceBetween: 5,
        navigation: {
          nextEl: '.gbox-swiper-next',
          prevEl: '.gbox-swiper-prev'
        },
        breakpoints: {
          680: {
              slidesPerView: 5.5,
              spaceBetween: 20,
          },
          1280: {
              slidesPerView: 7.5,
              spaceBetween: 20,
          }
        }
      })

    }
  },
  methods:{
    openModal(){
      $("#logModal").modal('show')
    },
    toggleFav(){
      this.showFav = !this.showFav
    },
    toggleSearch(){
      this.showSearch = !this.showSearch
    },
    cancelSearch(){
      this.showSearch = false
      this.searchinput = ""
    },	
    showProvider(){
      $('.modal-filbox').addClass('aaa')
      $('body').addClass('noscroll')
    },
    changeProvider(option){
      if(option !== this.providerSelected){
        this.providerSelected = option
      }
      $('.modal-filbox').removeClass('aaa')
      $('body').removeClass('noscroll')
      this.showFav = false
      // if(option === this.providerSelected){
      // 	return
      // }else{
      // 	this.providerSelected = option
      // }
    },
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
    // launchGame(option){
    // 	if (this.sessionToken) {
    //     this.gameLaunching = true
    // 		var vm = this
    //     let player_id = this.accountID
    //     let auth_token = this.sessionToken
    //     let game_code = ""
    //     let lang_code = "en"
    //     let provider = option
    //     let game_type = "FH"
    //     this.$store
    //       .dispatch("user/launchAwc", { player_id, auth_token,game_code, lang_code, provider, game_type })
    //       .then(response => {
    //         if (response.success == true) {
    // 					setTimeout(() => {
    // 						window.open(response.data, "_blank")
    //             vm.gameLaunching = false
    // 					}) 
    //         } else {
    //           vm.gameLaunching = false        
    //           if((typeof response.status) != 'object'){
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       })
    //       .catch(response => {
    //         vm.gameLaunching = false
    //         if((typeof response.status) != 'object'){
    //           if(response.status === 'free_credit_detected'){
    //             this.$swal({
    //               title: vm.$tc("ui.attention"),
    //               text: vm.$tc("message.list.free_credit_detected"),
    //               showCancelButton: true,
    //               type: "info",
    //               confirmButtonText: vm.$tc("ui.ok"),
    //               cancelButtonText: vm.$tc("ui.deposit"),
    //             }).then(result => {
    //               if (result.value) {
    //                 vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
    //                 
    //               } else if (result.dismiss) {
    //                 if(result.dismiss === 'cancel'){
    //                   vm.$router.push("/deposit").catch(error =>{})
    //                 }
    //               }
    //             });
    //           }else{
    //             // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //             this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //           }
    //         }
    //       });
    //   }else{
    // 		$("#logModal").modal("show")
    // 	}
    // }
  }
}
</script>
  